import './Components.scss';
import ImageAsset from './ImageAsset';

function Button(props: {
  text: string,
  src?: string,
  width?: number,
  height?: number,
  onClick: Function,
  disabled?: boolean,
  asset?: string
}) {
  return (
    <div className={`button-text button ${props.disabled ? 'disabled' : ''}`}  onClick={() => props.onClick()}>
      {/* <ImageAsset name={props.asset}></ImageAsset> */}
      {props.text}
    </div>
  );
}

export default Button;
